import React__default from 'react';
import clsx from 'clsx';
import { KImageWidgetAnimationType } from './index.props.js';
import StyledKImageWidget, { classes } from './index.styled.js';
import KImageWidgetUrl from './KImageWidgetUrl/index.js';

var KImageWidget = function (_a) {
    var _b, _c;
    var _d = _a.testId, testId = _d === void 0 ? "KImageWidget" : _d, className = _a.className, id = _a.id, _e = _a.backgroundColor, backgroundColor = _e === void 0 ? "transparent" : _e, image = _a.image, url = _a.url, position = _a.position, imageOverride = _a.imageOverride;
    var imageRender = function () {
        if (imageOverride) {
            return imageOverride;
        }
        if (image === null || image === void 0 ? void 0 : image.url) {
            return (React__default.createElement("img", { onContextMenu: function (e) { return e.preventDefault(); }, "data-testid": "".concat(testId, "-img"), className: clsx("KImageWidget-img", classes.img, (position === null || position === void 0 ? void 0 : position.cover) && classes.imgCover), src: image.url, alt: image.alt || (url === null || url === void 0 ? void 0 : url.title) || "", style: { minHeight: image.minHeight } }));
        }
        return null;
    };
    return (React__default.createElement(StyledKImageWidget, { "data-testid": testId, id: id, className: clsx("KImageWidget", className), animationType: (image === null || image === void 0 ? void 0 : image.animationType) || KImageWidgetAnimationType.NoAnimation, style: {
            backgroundColor: backgroundColor,
            justifyContent: (_b = position === null || position === void 0 ? void 0 : position.horizontal) !== null && _b !== void 0 ? _b : "center",
            alignItems: (_c = position === null || position === void 0 ? void 0 : position.vertical) !== null && _c !== void 0 ? _c : "center",
            minHeight: image === null || image === void 0 ? void 0 : image.minHeight,
            borderRadius: image === null || image === void 0 ? void 0 : image.borderRadius
        } },
        React__default.createElement(KImageWidgetUrl, { url: url, image: image }, imageRender())));
};

export { KImageWidget as default };
//# sourceMappingURL=index.js.map
